import cn from 'classnames';
import { FC, useEffect, useMemo, useState } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import 'swiper/css';
import { Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSetGameBoxType } from '../../hoc/useSetGameBoxType';
import {
    getActiveGameBoxCategoriesUnique,
    getCurrentProgresiveMission,
    getCurrentRace,
    getDailyraffle,
    getGameBoxBonusCode,
    getGameBoxDepositFs,
    getGameBoxDesaFio,
    getGameBoxDiaRioFs,
    getGameBoxFreespins,
    getGameBoxFunMission,
    getGameBoxGoti,
    getGameBoxOtherFirstTagMission,
    getGameBoxVip2,
    getGameBoxWagering,
    getGameBoxWageringWof,
    getGameBoxWlc2k,
    getGameBoxWofFS,
    getGameInfo,
    getMiniGamesList,
    getSportWithTeamMission,
    getTournamentGameBoxMission,
} from '../../store/selectors';
import { GAME_BOX_ITEMS_LIST } from '../../utils/constants';
import GameBoxCategory from '../GameBoxCategory';
import './styles.scss';

interface IGameBoxWidget {
    gameBoxType: string;
    gameBoxWidgetVisibility?: boolean;
    gameBoxWidgetVisibilityHandler?: (st?: boolean) => void;
    closeGame?: () => void;
    isWidget?: boolean;
    isGame?: boolean;
    isLandscape?: boolean;
    setIsOpen?: (st?: boolean) => void;
    storedRaceValue?: string | null;
}

const Categories: FC<IGameBoxWidget> = ({
    gameBoxType,
    gameBoxWidgetVisibilityHandler,
    gameBoxWidgetVisibility,
    closeGame,
    isWidget,
    isGame,
    isLandscape,
    setIsOpen,
    storedRaceValue,
}) => {
    const [swiperInstance, setSwiperInstance] = useState<any>(null);
    const activeGameBoxCategories = useSelector(getActiveGameBoxCategoriesUnique);
    const gameInfo = useSelector(getGameInfo);
    const onlyBonusMission = gameInfo?.bonusMissionId;
    const setGameBoxTag = useSetGameBoxType();
    const [activeTags, setActiveTags] = useState<string[]>([]);

    const hardCodeTransform = useMemo(
        () => ({
            /*raffle: {
                mission: getGameBoxRaffleMission,
                title: 'raffle',
                img: 'weeklyDraw',
                type: 'raffle',
                wagerImg: 'weeklyDraw',
                width: '22',
            },*/
            tournament: {
                mission: getTournamentGameBoxMission,
                title: 'tournament',
                img: 'missions',
                type: 'tournament',
                wagerImg: 'gos',
                width: '34',
            },
            money: {
                mission: getGameBoxWagering,
                title: 'money',
                img: 'deposit',
                type: 'money',
                wagerImg: '',
            },
            freespins: {
                mission: getGameBoxFreespins,
                title: 'freespins',
                img: 'freeSpin',
                type: 'freespins',
                wagerImg: 'spin',
                width: '42',
            },
            vip2: {
                mission: getGameBoxVip2,
                title: 'vip2',
                img: 'vip2',
                type: 'vip2',
                wagerImg: 'spin',
                width: '42',
            },
            Dailyraffle: {
                mission: getDailyraffle,
                title: 'Dailyraffle',
                img: 'Dailyraffle',
                type: 'Dailyraffle',
                wagerImg: 'Dailyraffle',
                width: '18',
            },
            desafio: {
                mission: getGameBoxDesaFio,
                title: 'desafio',
                img: 'desafio',
                type: 'desafio',
                wagerImg: 'spin',
                width: '42',
            },
            wlc2k: {
                mission: getGameBoxWlc2k,
                title: 'wlc2k',
                img: 'wlc2k',
                type: 'wlc2k',
                wagerImg: 'coin',
                width: '18',
            },
            goti: {
                mission: getGameBoxGoti,
                title: 'goti',
                img: 'goti',
                type: 'goti',
                wagerImg: 'spin',
                width: '42',
            },
            bonuscode: {
                mission: getGameBoxBonusCode,
                title: 'bonuscode',
                img: 'bonuscode',
                type: 'bonuscode',
                wagerImg: 'spin',
                width: '42',
            },
            diariofs: {
                mission: getGameBoxDiaRioFs,
                title: 'diariofs',
                img: 'diariofs',
                type: 'diariofs',
                wagerImg: 'spin',
                width: '42',
            },
            depositfs: {
                mission: getGameBoxDepositFs,
                title: 'depositfs',
                img: 'depositfs',
                type: 'depositfs',
                wagerImg: 'coin',
                width: '18',
            },
            wageringwof: {
                mission: getGameBoxWageringWof,
                title: 'wageringwof',
                img: 'wageringwof',
                type: 'wageringwof',
                wagerImg: 'spin',
                width: '42',
            },
            wofFS: {
                mission: getGameBoxWofFS,
                title: 'wofFS',
                img: 'wofFS',
                type: 'wofFS',
                wagerImg: 'spin',
                width: '42',
            },
            welcome: {
                mission: getCurrentProgresiveMission,
                title: 'welcome',
                img: 'welcomeBonus',
                type: 'progressiveMissions',
                wagerImg: 'coin',
                width: '18',
            },
            sportWithTeam: {
                mission: getSportWithTeamMission,
                title: 'sportWithTeam',
                img: 'sportWithTeam',
                type: 'sportWithTeam',
                wagerImg: 'coin',
                width: '18',
            },
            race: {
                mission: getCurrentRace,
                title: 'race',
                img: 'race',
                type: 'race',
                wagerImg: '',
            },
            miniGames: {
                mission: getMiniGamesList,
                title: 'miniGames',
                img: 'miniGames',
                type: 'miniGames',
                wagerImg: '',
            },
            other: {
                mission: getGameBoxOtherFirstTagMission,
                title: 'other',
                img: 'other',
                type: 'other',
                wagerImg: 'other',
                width: '26',
            },
            funMission: {
                mission: getGameBoxFunMission,
                title: 'funMission',
                img: 'funBonus',
                type: 'funBonus',
                wagerImg: 'diamond',
                width: '20',
            },
        }),
        []
    );

    useEffect(() => {
        const gameListItem = isWidget || onlyBonusMission ? [...GAME_BOX_ITEMS_LIST, 'funMission'] : GAME_BOX_ITEMS_LIST;
        setActiveTags(
            activeGameBoxCategories
                .filter(g => isWidget || g !== "miniGames")
                .filter((g) => gameListItem.includes(g))
        );
    }, [activeGameBoxCategories, isWidget, onlyBonusMission]);

    useEffect(() => {
        if (swiperInstance) {
            const activeIndex = activeTags.findIndex((tag) => tag === gameBoxType);
            swiperInstance.slideTo(activeIndex);
        }
    }, [gameBoxType, activeTags, swiperInstance]);

    useEffect(() => {
        if (activeTags.length && !onlyBonusMission) {
            setGameBoxTag(activeTags[0]);
        }
    }, [activeTags.length, setGameBoxTag, onlyBonusMission]);

    const categoriesWrapperClasses = cn('game-box-widget-tab-items-wrapper', {
        mobile: isMobile,
        'mobile-widget': isWidget && isMobile,
    });

    const renderGameBoxCategory = (item: string) => (
        <GameBoxCategory
            key={item}
            item={hardCodeTransform[item]}
            selected={gameBoxType}
            gameBoxWidgetVisibilityHandler={gameBoxWidgetVisibilityHandler}
            isWidget={isWidget}
            setIsOpen={setIsOpen}
            storedRaceValue={storedRaceValue}
        />
    );

    const isVertical = isLandscape && isMobile && !gameBoxWidgetVisibility && !isWidget;

    const slideCount = () => {
        if (isWidget) {
            if (isDesktop || (isMobile && isLandscape)) return 4.1;
            return 3.05;
        }

        if (isMobile && isLandscape && !gameBoxWidgetVisibility) return 2.7;
        if (isMobile && !isLandscape && !isWidget) return 2.4;

        return 4.1;
    };

    const widthOfSwiper = () => {
        if (isDesktop && isWidget) return '898px';
        if (isMobile && isLandscape) return '475px';
        if (isMobile && isWidget) return '375px';
        return '280px';
    };

    const GameBoxIconHeader = () => {
        return (
            <div className="game-box-widget-tab-items__headerSpace box-icon">
                <div className="game-box">
                    <img
                        onClick={() => gameBoxWidgetVisibilityHandler && gameBoxWidgetVisibilityHandler()}
                        src={'/static/images/mobile-box.png'}
                        width={26}
                        alt="box"
                    />
                </div>
                <div className="chevron" onClick={() => gameBoxWidgetVisibilityHandler && gameBoxWidgetVisibilityHandler()}>
                    {gameBoxWidgetVisibility ? (
                        <ReactSVG src="/static/images/close.svg" />
                    ) : (
                        <ReactSVG src="/static/images/info.svg" />
                    )}
                </div>
            </div>
        );
    };

    return activeTags.length ? (
        <div className={categoriesWrapperClasses}>
            {isVertical && (
                <div className="my-bonuses__tags__demo__content">
                    <img src="/static/images/box.png" width={40} alt="box" />
                    <p>
                        Game<span>Box</span>
                    </p>
                </div>
            )}
            <div className={cn('game-box-widget-tab-items', { 'scroll-on-cat': isGame && isDesktop })}>
                {isMobile && !isWidget && (
                    <div className="game-box-widget-tab-items__headerSpace">
                        <div className="home">
                            <ReactSVG src="/static/images/home.svg" onClick={closeGame} />
                        </div>
                    </div>
                )}
                {onlyBonusMission && isGame ? (
                    <>
                        <div className={cn({ mobileMission: (isMobile && !isLandscape) || (isMobile && gameBoxWidgetVisibility) })}>
                            <GameBoxCategory key="funMission" item={hardCodeTransform['funMission']} selected={'funMission'} />
                        </div>
                        {isMobile && <GameBoxIconHeader />}
                    </>
                ) : isMobile || isWidget ? (
                    <>
                        <Swiper
                            onSwiper={setSwiperInstance}
                            direction={isVertical ? 'vertical' : 'horizontal'}
                            mousewheel={true}
                            slidesPerView={slideCount()}
                            modules={[Mousewheel]}
                            style={{
                                width: widthOfSwiper(),
                                height: isVertical ? '180px' : 'auto',
                            }}
                        >
                            {activeTags?.map((item) => (
                                <SwiperSlide key={item}>{renderGameBoxCategory(item)}</SwiperSlide>
                            ))}
                        </Swiper>
                        {isMobile && !isWidget && <GameBoxIconHeader />}
                    </>
                ) : (
                    activeTags?.map((item) => renderGameBoxCategory(item))
                )}
            </div>
        </div>
    ) : null;
};

export default Categories;
